import { render } from "./BehindScenesGallery.vue?vue&type=template&id=7121f952"
import script from "./BehindScenesGallery.vue?vue&type=script&lang=js"
export * from "./BehindScenesGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__